import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import type { Lang } from '../data/copy';
const options: {
  value: Lang;
  label: string;
}[] = [{
  value: 'en',
  label: 'EN'
}, {
  value: 'es',
  label: 'ES'
}];
export function LanguageToggle({
  className = ''
}: {
  className?: string;
}) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div role="group" aria-label={t.nav.languageLabel} className={`inline-flex items-center rounded-full border border-forest p-0.5 ${className}`} data-id="element-149" data-mp="2t5nsx7q6laun">
      {options.map(option => {
      const active = lang === option.value;
      return <button key={option.value} type="button" onClick={() => setLang(option.value)} aria-pressed={active} className={`rounded-full px-3 py-1.5 text-xs font-bold tracking-wide transition-colors duration-150 ease-out ${active ? 'bg-forest text-white' : 'text-forest/70 hover:text-forest'}`} data-id="element-150" data-mp="2f8r3nappo1fv">
            {option.label}
          </button>;
    })}
    </div>;
}